module.exports = __webpack_public_path__ + "img/glow-green-medium.30340134.png";